<template>
    <div id="af3-shortcode-one-pager-gallery-component">
        <div class="af3-shortcode-one-pager-gallery-component-image-container">
            <img class="af3-shortcodes-single-gallery-component-image" :src="floorplan.image.url" :alt="floorplan.image.alt" />
            <button class="zoom-button" @click="showLightbox()">
                <span class="zoom-icon">+</span>
            </button>
            <vue-easy-lightbox
                :visible="visible"
                :imgs="[floorplan.image.url]"
                :index="0"
                @hide="handleHide"
            />
        </div>
        <div class="af3-shortcode-one-pager-gallery-component-content">
            <div class="af3-shortcode-one-pager-gallery-component-content-title">
                <span v-html="floorplan.title"></span>
            </div>
            <div class="af3-shortcode-one-pager-gallery-component-content-data">
                <span class="af3-shortcode-one-pager-gallery-component-content-data-bedrooms">{{ floorplan.bedrooms }} BD | {{ floorplan.bathrooms }} BTH | {{ floorplan.size_max }} SQFT.</span>
                <!-- Render the Yardi fallback text in place of the price when set, otherwise
                     "Starting at $X,XXX" — but only when there's a real positive price.
                     Hide the line entirely when neither is available. -->
                <span
                    v-if="pricingUnavailableText"
                    class="af3-shortcode-one-pager-gallery-component-content-data-price"
                >{{ pricingUnavailableText }}</span>
                <span
                    v-else-if="hasValidPrice"
                    class="af3-shortcode-one-pager-gallery-component-content-data-price"
                >Starting at <span v-dollar-format="floorplan.price_min"></span></span>
            </div>
        </div>
    </div>

</template>
  
<script>

import { defineComponent, ref, watch, onMounted, reactive, computed } from 'vue';
import VueEasyLightbox from 'vue-easy-lightbox';

export default defineComponent({
    components: {VueEasyLightbox },
   
    props: { 
        floorplan: {
            type: Object,
            required: true
        }
    },

    setup(props) { 
        const visible = ref(false);

        const showLightbox = () => {
            visible.value = true;
        };

        const handleHide = () => {
            visible.value = false;
        };

        // Yardi "Pricing Unavailable" fallback text. null means "no fallback configured".
        const pricingUnavailableText = computed(() => {
            const fallback = props.floorplan.pricing_unavailable_text;
            return fallback && String(fallback).trim() !== '' ? fallback : null;
        });

        // Whether price_min is a real positive number worth rendering. Guards
        // against '$0' / '-$1' from empty / non-positive price_min values.
        const hasValidPrice = computed(() => {
            const value = Number(props.floorplan.price_min);
            return !Number.isNaN(value) && value > 0;
        });

    return {
        visible,
        showLightbox,
        handleHide,
        pricingUnavailableText,
        hasValidPrice
    };
  },


  
  
});
</script>